import { faLock, faLockOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";

const Container = styled.span`
    display: inline-flex;
`;

const Item = styled.span<{ color: string }>`
    flex-grow: 1;
    padding: 0.05em 0.6em;
    font-size: 1.5em;
    border: 3px solid ${(props) => props.color};
    color: ${(props) => props.color};
    cursor: pointer;

    &:first-child {
        transform-origin: right;
        border-radius: 0.7em 0 0 0.7em;
    }

    &:last-child {
        transform-origin: left;
        border-radius: 0 0.7em 0.7em 0;
    }

    &.selected {
        background-color: ${(props) => props.color};
        color: white;
    }

    transition: 100ms ease-in;

    @media only screen and (min-width: 600px) {
        &:hover:not(:disabled) {
            transition: 200ms ease-out;
            transform: rotate3d(0.1, 1, 0, 30deg);
        }
    }
`;

type OpenCloseButtonProps = {
    open: boolean;
    onChange: (open: boolean) => void;
    className?: string;
    style?: React.CSSProperties;
};

export function OpenCloseButton({ open, onChange, className, style }: OpenCloseButtonProps) {
    return (
        <Container className={className} style={style}>
            <Item color="#ec454f" className={open ? "selected" : ""} onClick={() => open && onChange(false)}>
                <FontAwesomeIcon icon={faLock} />
            </Item>
            <Item color="#56a44f" className={open ? "" : "selected"} onClick={() => !open && onChange(true)}>
                <FontAwesomeIcon icon={faLockOpen} />
            </Item>
        </Container>
    );
}
